import { Dialog } from 'vant';

export const alert = msg => {
  Dialog.alert({
    message: msg,
    confirmButtonColor: '#ff8000',
  });
};

export const getUrlParams = (location = window.location.search) => {
  location.indexOf('?') > -1 && (location = location.slice(1));
  return (
    (location &&
      location.split('&').reduce((result, item) => {
        const [key, value] = item.split('=');
        result[key] = value;
        return result;
      }, {})) ||
    {}
  );
};

export const getHashParams = () => {
  return getUrlParams(location.hash.split('?')[1] || '');
};

export const getSearchParams = () => {
  return getUrlParams(location.search);
};

export const getFullUrlParams = () => {
  const hashParams = getHashParams();
  const searchParams = getSearchParams();
  return Object.assign(searchParams, hashParams);
};

export const getCookieObj = () => {
  return document.cookie.split(';').reduce((obj, str) => {
    const [key, value] = str.split('=');
    obj[key.trim()] = value;
    return obj;
  }, {});
};

export const copyByClipboard = (text) => {
  return navigator.clipboard.writeText(text);
};

export const copyByExecCommand = (text) => {
  return new Promise((resolve, reject) => {
    try {
      const textArea = document.createElement("textArea");
      textArea.value = text;
      textArea.style.width = 0;
      textArea.style.position = "fixed";
      textArea.style.left = "-999px";
      textArea.style.top = "10px";
      textArea.setAttribute("readonly", "readonly");
      document.body.appendChild(textArea);

      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);

      resolve();
    } catch (e) {
      reject(e);
    }
  });
};

export const copyToClipboard = ({content, successTips}) => {
  let result = Promise.resolve();
  if (navigator.clipboard && navigator.permissions) {
    result = copyByClipboard(content);
  } else {
    result = copyByExecCommand(content);
  }
  result.then(() => {
    alert(successTips);
  }).catch((e) => {
    alert($t("复制失败"));
  });
};

// 防抖
export function debounce(fn, interval = 1000) {
  let timmer;
  return function fnWrap(...args) {
    timmer && clearTimeout(timmer);
    const me = this;
    timmer = setTimeout(() => {
      fn.apply(me, args);
    }, interval);
  };
}

export function remove(arr, val) {
  if (isArray(arr)) {
    var index = arr.indexOf(val);
    if (index > -1) {
      arr.splice(index, 1);
    }
  }
}

export const loadCSS = (path) => {
  if (!path || path.length === 0) {
      throw new Error('argument "path" is required !');
  }
  var head = document.getElementsByTagName('head')[0];
  var link = document.createElement('link');
  link.href = path;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  head.appendChild(link);
}

export const loadJS = (url, cb) => {
  let script = document.createElement('script');
  script.type = "text/javascript"
  script.onload = function () {
    !!cb && cb();
  };
  script.onerror = function (error) {
    console.log(error)
  }
  script.src = url;
  script.async = true;

  let head = document.getElementsByTagName('head')[0];
  head.appendChild(script);
}